<template>
  <div>

    <EventTicketEditorModal 
      ref="event-ticket-editor-modal"
      :id="selected_ticket_id"
      :event="item"
      @created="ticket_created"
      @updated="ticket_updated"
    />

    <EventFormAvailability 
      v-if="local_item"

      :item="local_item"

      @change="event_changed"
      @update="update_event"
      @create="create_event"
    />

    <div v-if="ticket_items.length === 0" class="empty-participant-message">
      <i class="mdi mdi-ticket big-icon"></i>

      <p class="info-text">Det finns inga biljetter tillgängliga på evenemanget.</p>
      <p>Innan du kan publicera evenemanget måste du ha minst en biljett!</p>

      <memlist-icon-button
        class="mt-4"
        icon="menu-icon flaticon2-plus"
        :text="$t('EVENT.CREATE_TICKET')"
        variant="primary"
        @click="create_ticket_clicked"
      />
    </div>
    <div v-else>

      <m-row class="mt-4">
        <m-col lg="12" class="mb-4 d-flex justify-end">
          <memlist-icon-button
            icon="menu-icon flaticon2-plus"
            :text="$t('EVENT.NEW_TICKET')"
            variant="primary"
            @click="create_ticket_clicked"
          />

        </m-col>
      </m-row>

      
      <memlist-static-table
        id="ticket-table"
        style="width: 100%; table-layout: fixed;"
        class="table-striped"
        :fields="ticket_headers"
        :items="ticket_items"
        head-variant="light"
        ref="ticket-table"
      >
        <template #cell(actions)="data">

          <div class='d-flex justify-content-end'>
            <memlist-table-button @click="edit_ticket_clicked(data.item)" class="mr-2" svg="/assets/svg/pencil-square.svg" :tooltip="$t('COMMON.EDIT')" />
            <memlist-table-button @click="delete_ticket_clicked(data.item)" svg="/assets/svg/trash2.svg" :tooltip="$t('COMMON.DELETE')" />
          </div>
        </template>

      </memlist-static-table>

      <Confirm
        :title="$t('EVENT.TICKET.DELETE_TICKET')"
        :message="$t('EVENT.TICKET.DELETE_TICKET_INFO')"
        ref="delete-ticket"
        :type="'success'"
        :confirm="$t('COMMON.YES')"
        :cancel="$t('COMMON.NO')"
        @confirm="delete_ticket_confirm"
      />
    </div>
  </div>
</template>

<script>
import { get_base_url, downloadWithAxios } from '@/core/services/fileDownload';
import EventTicketEditorModal from '@/view/pages/ml/events/forms/EventTicketEditorModal.vue';
import axios from 'axios';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import EventFormAvailability from './EventFormAvailability.vue';

export default {
  name: 'EventFormTickets',
  props: ['item'],
  mixins: [ toasts ],
  components: {
    EventTicketEditorModal,
    EventFormAvailability
  },
  watch: {

    item: {
      deep: true,
      handler(val) {
        console.log('loading tickets')
        this.load_tickets(this.item.event_id);
        this.local_item = JSON.parse(JSON.stringify(this.item));
      },
      immediate: true
    },
    
  },
  data() {
    return {
      ticket_id_to_delete: null,
      selected_ticket_id: null,
      ticket_items: [],

      ticket_headers: [
        {
          key: 'name',
          label: this.$t('EVENT.TICKET.NAME'),
          sortable: true,
          thClass: 'pl-7 align-middle',
          tdClass: 'pl-7'
        },
        {
          key: 'max_quantity',
          label: this.$t('EVENT.TICKET.MAX_QUANTITY'),
          sortable: true,
          thClass: 'w-150px align-middle',
          tdClass: 'w-150px',
        },
        
        {
          key: 'used_quantity',
          label: this.$t('EVENT.TICKET.USED_QUANTITY'),
          sortable: true,
          thClass: 'w-150px align-middle',
          tdClass: 'w-150px',
        },
        {
          key: 'actions',
          label: this.$t('COMMON.ACTIONS'),
          thClass: 'text-right',
        },
      ],

      member_event_to_delete: null,
      member_event: null,
      member_event_id: null,
      member_events: [],
      local_item: {}
    }
  },
  methods: {

    event_changed(item) {
      this.$emit('change', item);
    },

    update_event(item) {
      this.$emit('update', item);
    },

    create_event(item) {
      this.$emit('create', item);
    },

    ticket_created(item) {
      this.load_tickets(this.item.event_id);
    },
    ticket_updated(item) {
      this.load_tickets(this.item.event_id);
    },

    create_ticket_clicked() {
      this.selected_ticket_id = null;
      
      this.$refs['event-ticket-editor-modal'].reset();
      this.$refs['event-ticket-editor-modal'].show();
    },

    save_event() {},

    edit_ticket_clicked(item) {
      this.selected_ticket_id = item.id;
      this.$refs['event-ticket-editor-modal'].show();
    },

    
    async load_tickets(event_id) {
      try {
        const res = await axios.get(`/events/${event_id}/tickets`);
      
        if (res.status === 200) {
          this.ticket_items = res.data;
        }
      }
      catch (err) {
        console.error('load_tickets', err);
      }
      
    },

    delete_ticket_clicked(item) {
      this.ticket_id_to_delete = item.id;
      this.$refs['delete-ticket'].show();
    },

    async delete_ticket_confirm() {
      try {
        const res = await axios.delete(`/events/tickets/${this.ticket_id_to_delete}`);
        
        if (res.status === 204) {
          this.load_tickets(this.item.event_id);

          this.toastr('success', this.$t('COMMON.OK'), this.$t('EVENT.TICKET.DELETED'));
        } else {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('EVENT.TICKET.UNABLE_DELETE'));
        }
      }
      catch (err) {
        console.error(err);
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('EVENT.TICKET.UNABLE_DELETE'));
      }
    
    },
    
  }
}
</script>
<style scoped>
.empty-participant-message {
  text-align: center;
  padding: 4rem 1rem;
  background: #f9f9f9;
  border: 1px dashed #ccc;
  border-radius: 8px;
}

.big-icon {
  font-size: 4rem;
  color: #2D9BF0;
  margin-bottom: 1rem;
}

.info-text {
  font-size: 1.2rem;
  color: #555;
}
</style>